import { createContext } from 'react';
import { PrematchPageableOfferStore } from '@gp/offer';

const defaultValue: PrematchPageableOfferStore = new PrematchPageableOfferStore();
export const PrematchPageStoreContext = createContext<PrematchPageableOfferStore>(defaultValue);